import { Component, OnInit } from '@angular/core';
import { MatPaginatorIntl, PageEvent } from '@angular/material/paginator';
import { HomeService } from 'src/home/home.service';
import { PaginatorService } from 'src/home/paginator.service';
import { CrmClient, ListCrmClients } from 'src/models/Crm-client.interface';
import Swal from 'sweetalert2';
import { CrmService } from '../services/crm.service';

@Component({
  selector: 'app-crm-clients-list',
  templateUrl: './crm-clients-list.component.html',
  styleUrls: ['./crm-clients-list.component.css'],
  providers: [{ provide: MatPaginatorIntl, useClass: PaginatorService }]
})
export class CrmClientsListComponent implements OnInit {

  clients: CrmClient[] = [];
  totalClients: number = 1;

  public isLoading: boolean = false;

  constructor(private homeService: HomeService, private crmService: CrmService) { }

  ngOnInit(): void {
    this.handleLoadClients();
  }

  handleLoadClients(pageNumber: number = 1): void {
    this.isLoading = true
    this.crmService.getClients(pageNumber).subscribe(
      (data: ListCrmClients) => {
        this.isLoading = false;
        this.clients = data.results;
        this.totalClients = data.totalClients
      },
      (error) => {
        Swal.fire({
          text: 'Hubo un error al cargar los clientes',
          icon: 'error',
          confirmButtonText: 'OK',
          confirmButtonColor: '#d33'
        });
      }
    );
  }

  handlePageEvent($event: PageEvent): void {
    this.handleLoadClients($event.pageIndex + 1);
  }

}
